import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("hero-section", {
    model: {
      defaults: {
        components: html`
          <section class="relative md:h-[700px] h-[400px]">
            <img
              src="https://via.placeholder.com/1000x700"
              alt="Hero Background"
              class="absolute inset-0 w-full h-full object-cover filter brightness-60 z-0"
            />
            <div
              class="container mx-auto h-full px-4 relative z-10 flex flex-col justify-center"
            >
              <div
                class="flex flex-col md:flex-row items-center justify-between space-y-8 md:space-y-0 md:space-x-8"
              >

                <div
                  class="text-white flex-1 flex flex-col justify-center gap-y-2 md:gap-y-10"
                >
                  <h1 class="md:text-5xl text-2xl font-bold">
                    Unlock Your Business Potential
                  </h1>
                  <p class="md:text-xl text-lg">
                    Our delivery and shipping services offer a wide range of
                    plans for your business which grow values of your business
                    globally.
                  </p>
                  <a href="#" class="p-1">
                    <button
                      class="px-3 py-2 bg-[var(--primary)] rounded text-white w-36"
                    >
                      Connect with us
                    </button>
                  </a>
                </div>


                <div class="bg-[#F0F0F0] hidden md:block rounded shadow-md text-black w-full md:w-[480px]">
  <h2 class="text-xl font-bold text-center bg-[var(--primary)] text-white p-2  mb-4">
    Calculate Your Parcel Cost & Book
  </h2>
  <form class="space-y-4 opacity-60 px-6 py-4" novalidate>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <select
        id="pickup-branch"
        class="border px-4 py-2 rounded text-gray-700"
        required
      >
        <option value="" class="hover:bg-[var(--primary)] hover:text-white">
          Search Pickup Branch
        </option>
      </select>
      <select
        id="destination"
        class="border px-4 py-2 rounded text-gray-700 max-h-[100px] overflow-y-scroll max-w-52"
        required
      >
        <option value="" class="hover:bg-[var(--primary)] hover:text-white max-w-52 font-small">
          Search Destination City
        </option>
      </select>
    </div>

   <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm" id="product-type-group">
  <div class="space-y-2" data-group="pickup" id="pickup-options"></div>
  <div class="space-y-2" data-group="delivery" id="delivery-options"></div>
</div>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <input
        type="number"
        placeholder="Weight (Kgs)"
        class="p-2 border rounded w-full"
        required
      />
      <select
        id="shipment-type"
        class="border px-4 py-2 rounded text-gray-700"
        required
      >
        <option value="" class="hover:bg-[var(--primary)] hover:text-white">
          Search Shipment Type
        </option>
      </select>
    </div>


    <div class="text-center">
      <button
        type="submit"
        class="bg-[var(--primary)] text-white py-2 px-6 rounded mt-2"
      >
        Submit
      </button>
    </div>
  </form>
</div>
            <div class="absolute -bottom-16 w-full flex justify-center z-10">
              <div
                class="flex flex-col items-center text-white rounded gap-4 md:gap-x-4 max-w-4xl px-4 bg-[#2B2828] py-4 w-full"
              >
                <div class="relative w-full">
                  <form>
                    <p class="md:text-lg font-semibold">
                      Tracking ID / Order Number*
                    </p>
                    <div class="flex gap-x-2 w-full  ">
                      <label class="w-full">
                        <input
                          type="text"
                          id="tracking-number"
                          name="search"
                          placeholder="Enter your tracking number, (+977)mobile number or reference number"
                          class="outline-none px-4 py-2 w-full rounded bg-white text-black"
                        />
                      </label>
                      <button
                        type="submit"
                        id="track-btn"
                        class="px-4 py-2 bg-[var(--primary)] h-[40px] rounded ripple-effect overflow-hidden relative cursor-pointer text-white"
                      >
                        Track
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        `,
        script: function () {
          const pickupBranch = this.querySelector("#pickup-branch");
          const destinationBranch = this.querySelector("#destination");
          const shipmentType = this.querySelector("#shipment-type");
          const productTypeGroup = document.querySelector(
            "#product-type-group"
          );

          let validator;
          const initLib = function () {
            //@ts-ignore
            validator = new JustValidate(form);
            validator.addField(document.querySelector("#tracking-number"), [
              {
                rule: "required",
                errorMessage: "Tracking number is required",
              },
            ]);
          };
          const form = document.querySelector("form") as HTMLFormElement;
          form.addEventListener("submit", function (e) {
            e.preventDefault();
            const tracking = document.getElementById(
              "tracking-number"
            ) as HTMLInputElement;
            validator.onSuccess((isValid) => {
              if (!isValid) {
                console.log("Form validation failed.");
                return;
              }
              const trackingNumber = tracking.value.trim();
              if (trackingNumber) {
                window.location.href = `track/?search=${encodeURIComponent(
                  trackingNumber
                )}`;
              }
            });
          });

          function fetchBranches() {
            fetch(
              "https://apiservice.careinfosolutions.com/apiservice/api/v1/public/branch/"
            )
              .then((res) => res.json())
              .then((data) => {
                data.forEach((branch) => {
                  const option = document.createElement("option");
                  option.value = branch.id;
                  option.textContent = branch.name;

                  pickupBranch.appendChild(option);
                });
              })
              .catch((err) => {
                console.error("Failed to fetch branches", err);
              });
          }
          function fetchDestination() {
            fetch(
              "https://apiservice.careinfosolutions.com/apiservice/api/v1/public/destination/"
            )
              .then((res) => res.json())
              .then((data) => {
                data.forEach((destination) => {
                  const option = document.createElement("option");
                  option.value = destination.id;
                  option.textContent = destination.name;

                  destinationBranch.appendChild(option);
                });
              })
              .catch((err) => {
                console.error("Failed to fetch destination", err);
              });
          }
          function fetchShipmentType() {
            fetch(
              "https://apiservice.careinfosolutions.com/apiservice/api/v1/public/product-type/"
            )
              .then((res) => res.json())
              .then((data) => {
                data.forEach((destination) => {
                  const option = document.createElement("option");
                  option.value = destination.id;
                  option.textContent = destination.name;

                  shipmentType.appendChild(option);
                });
              })
              .catch((err) => {
                console.error("Failed to fetch shipment", err);
              });
          }

          function fetchProductTypes() {
            const pickupContainer = document.getElementById("pickup-options");
            const deliveryContainer =
              document.getElementById("delivery-options");

            if (!pickupContainer || !deliveryContainer) return;

            // Clear existing options
            pickupContainer.innerHTML = "";
            deliveryContainer.innerHTML = "";

            fetch(
              "https://apiservice.careinfosolutions.com/apiservice/api/v1/public/service-type/"
            )
              .then((res) => res.json())
              .then((data) => {
                data.forEach((item) => {
                  const label = document.createElement("label");
                  label.className = "flex items-center gap-2";

                  const input = document.createElement("input");
                  input.type = "radio";
                  input.className = "form-checkbox";
                  input.name = "delivery"; // or "pickup" — depends on type
                  input.value = item.id;

                  const span = document.createElement("span");
                  span.textContent = item.name;

                  label.appendChild(input);
                  label.appendChild(span);

                  // You can separate logic here based on item.name or add a new field in API like `type: "pickup" | "delivery"`
                  if (item.name.toLowerCase().includes("pickup")) {
                    input.name = "pickup";
                    pickupContainer.appendChild(label);
                  } else {
                    input.name = "delivery";
                    deliveryContainer.appendChild(label);
                  }
                });
              })
              .catch((err) => {
                console.error("Failed to fetch product types", err);
              });
          }

          fetchBranches();
          fetchDestination();
          fetchShipmentType();
          fetchProductTypes();

          const parcelForm = document.querySelector("form.space-y-4");
          if (parcelForm) {
            parcelForm.addEventListener("submit", function (e) {
              e.preventDefault();

              const pickupBranch = document.getElementById(
                "pickup-branch"
              ) as HTMLSelectElement | null;
              const destination = document.getElementById(
                "destination"
              ) as HTMLSelectElement | null;
              const weight = parcelForm.querySelector(
                'input[type="number"]'
              ) as HTMLInputElement | null;
              const shipmentType = document.getElementById(
                "shipment-type"
              ) as HTMLSelectElement | null;
              const pickupOption = parcelForm.querySelector(
                'input[name="pickup"]:checked'
              ) as HTMLInputElement | null;
              const deliveryOption = parcelForm.querySelector(
                'input[name="delivery"]:checked'
              ) as HTMLInputElement | null;

              const payload = {
                pickupBranch: pickupBranch?.value || "",
                destination: destination?.value || "",
                weight: weight?.value || "",
                shipmentType: shipmentType?.value || "",
                pickupOption: pickupOption?.value || null,
                deliveryOption: deliveryOption?.value || null,
              };

              fetch(
                "https://apiservice.careinfosolutions.com/apiservice/api/v1/public/get-quote/",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(payload),
                }
              )
                .then(function (response) {
                  if (!response.ok) {
                    throw new Error("Failed to submit the form");
                  }
                  return response.json();
                })
                .then(function (data) {
                  alert("Form submitted successfully!");
                  console.log("Response:", data);
                })
                .catch(function (error) {
                  console.error("Error during form submission:", error);
                  alert("There was an error submitting the form.");
                });
            });
          }

          //@ts-ignore
          if (typeof JustValidate === "undefined") {
            const script = document.createElement("script");
            script.onload = initLib;
            script.src =
              "https://unpkg.com/just-validate@latest/dist/just-validate.production.min.js";
            document.body.appendChild(script);
          } else {
            initLib();
          }
        },
      },
    },
  });
};
